module.exports = "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-design-icons-svg/paths/arrow-left.json
// module id = 418
// module chunks = 0